/**
 * Injects circular discount badges onto product cards that were re-rendered
 * by apps such as Globo Smart Product Filters.
 */
(function () {
  const settings = window.themeDiscountBadge || {};
  const GRID_SELECTORS = '#gf-products, #product-grid, [data-globo-filter-items], [data-discount-badge="true"]';

  const parseMoney = (text) => {
    if (!text) return 0;
    const normalized = String(text)
      .replace(/[^\d,.-]/g, '')
      .trim();
    if (!normalized) return 0;
    if (normalized.includes('.') && normalized.includes(',')) {
      return parseFloat(normalized.replace(/\./g, '').replace(',', '.'));
    }
    if (normalized.includes(',')) {
      return parseFloat(normalized.replace(',', '.'));
    }
    return parseFloat(normalized);
  };

  const getPrices = (card) => {
    const salePriceEl = card.querySelector('.price__sale .price-item--sale, .price-item--sale');
    const compareEl = card.querySelector('.price__sale s.price-item--regular, s.price-item--regular, .price-item--regular.variant-item__old-price');
    if (!salePriceEl || !compareEl) return null;

    const price = parseMoney(salePriceEl.textContent);
    const compareAt = parseMoney(compareEl.textContent);
    if (!(compareAt > price) || !(price > 0)) return null;

    return { price, compareAt };
  };

  const buildBadge = (percent) => {
    const threshold = Number(settings.threshold) || 40;
    const isHigh = percent >= threshold;
    const badge = document.createElement('div');
    badge.className = 'discount-percentage-badge';
    badge.style.setProperty('--discount-badge-bg', isHigh ? settings.colorHigh || '#FEC802' : settings.colorLow || '#000000');
    badge.style.setProperty('--discount-badge-text', isHigh ? settings.textHigh || '#000000' : settings.textLow || '#FFFFFF');
    badge.style.setProperty('--discount-badge-size', `${settings.size || 48}px`);
    badge.setAttribute(
      'aria-label',
      String(settings.label || '__PCT__% off').replace('__PCT__', String(percent))
    );

    const value = document.createElement('span');
    value.className = 'discount-percentage-badge__value';
    value.setAttribute('aria-hidden', 'true');
    value.textContent = `-${percent}%`;
    badge.appendChild(value);
    return badge;
  };

  const injectBadge = (card) => {
    if (card.querySelector('.discount-percentage-badge')) return;

    const prices = getPrices(card);
    if (!prices) return;

    const percent = Math.round(((prices.compareAt - prices.price) * 100) / prices.compareAt);
    if (percent <= 0) return;

    const media = card.querySelector('.card__media');
    if (!media) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'card__discount-badge';
    wrapper.appendChild(buildBadge(percent));
    media.appendChild(wrapper);
  };

  const shouldEnhanceGrid = (root) => {
    if (root.closest('[data-discount-badge="false"]')) return false;
    if (root.matches('[data-discount-badge="true"]') || root.closest('[data-discount-badge="true"]')) return true;
    if (root.matches('#gf-products, [data-globo-filter-items]') || root.closest('#gf-products, [data-globo-filter-items]')) {
      return settings.enabled !== false;
    }
    return settings.enabled !== false;
  };

  const enhance = (root = document) => {
    const grids = root.matches?.(GRID_SELECTORS)
      ? [root]
      : [...root.querySelectorAll(GRID_SELECTORS)];

    if (!grids.length && root === document) {
      grids.push(
        ...document.querySelectorAll('#gf-products, #product-grid, [data-globo-filter-items]')
      );
    }

    grids.forEach((grid) => {
      if (!shouldEnhanceGrid(grid)) return;
      grid.querySelectorAll('.card-wrapper').forEach(injectBadge);
    });
  };

  const observe = () => {
    const targets = document.querySelectorAll('#ProductGridContainer, #gf-products, #product-grid, [data-globo-filter-items]');
    if (!targets.length) return;

    const observer = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => mutation.addedNodes.length)) {
        enhance();
      }
    });

    targets.forEach((target) => {
      observer.observe(target, { childList: true, subtree: true });
    });
  };

  const init = () => {
    enhance();
    observe();
    document.addEventListener('globoFilterRendered', enhance);
    document.addEventListener('spf:loaded', enhance);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
